'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 10rem;\n  background: linear-gradient(0deg, rgba(0,0,0,0), rgba(0,0,0,0.5));\n'], ['\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 10rem;\n  background: linear-gradient(0deg, rgba(0,0,0,0), rgba(0,0,0,0.5));\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoothShade = _styledComponents2.default.div(_templateObject);

exports.default = BoothShade;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/booth-shade.js
// module id = 1332
// module chunks = 0